import $api from "http/index";

const BASE = "students/orders/";
const TPL_BASE = "students/order-templates/";

export const listOrders = (params) => $api.get(BASE, { params });
export const getOrder = (id) => $api.get(`${BASE}${id}/`);
export const createOrder = (data) => $api.post(BASE, data);
export const updateOrder = (id, data) => $api.patch(`${BASE}${id}/`, data);
export const deleteOrder = (id) => $api.delete(`${BASE}${id}/`);
export const submitOrder = (id) => $api.post(`${BASE}${id}/submit/`);
export const decideOrder = (id, payload) => $api.post(`${BASE}${id}/decide/`, payload);
export const signOrder = (id) => $api.post(`${BASE}${id}/sign/`);
export const downloadOrderPdf = (id) =>
  $api.get(`${BASE}${id}/pdf/`, { responseType: "blob" });

export const listTemplates = (params) => $api.get(TPL_BASE, { params });
export const createTemplate = (data) => $api.post(TPL_BASE, data);
export const updateTemplate = (id, data) => $api.patch(`${TPL_BASE}${id}/`, data);
export const deleteTemplate = (id) => $api.delete(`${TPL_BASE}${id}/`);

export const ORDER_KINDS = [
  { value: "enrollment", label: "О зачислении" },
  { value: "transfer", label: "О переводе" },
  { value: "academic_leave", label: "Об академическом отпуске" },
  { value: "academic_return", label: "О выходе из академ. отпуска" },
  { value: "expel", label: "Об отчислении" },
  { value: "reinstate", label: "О восстановлении" },
  { value: "graduate", label: "О выпуске" },
  { value: "course_advance", label: "О переводе на следующий курс" },
  { value: "practice", label: "О направлении на практику" },
  { value: "custom", label: "Произвольный" },
];

export const ORDER_STATUSES = [
  { value: "draft", label: "Черновик" },
  { value: "review", label: "На согласовании" },
  { value: "signed", label: "Подписан" },
  { value: "rejected", label: "Отклонён" },
  { value: "archived", label: "Архивирован" },
];
